import { useRef, useState } from "react";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import useOnClickOutside from "../../Hooks/useOnClickOutside/useOnClickOutside";
import { toast } from "react-toastify";
import { Heart, Image, Share2 } from "lucide-react";
import SharePopup from "../common/sharePopup/SharepPopup";
import GallaryPopup from "./GallaryPopup";
import { AuthModal } from "../../models/AuthModal";
import { FaHeart } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import Layout2 from "../../Layouts/Layout2";
import { CollectionPickerModal } from "../Collections/CollectionPickerModal";
import CollectionCreateModal from "../Collections/CollectionCreateModal";
import { CurrencySymbol } from "../../utils/enums";

export const ImageSection = ({ PropertyData, PropertyImages, agentData }) => {
  const ref = useRef(null);

  const [GallaryView, setGallaryView] = useState(false);

  useOnClickOutside(ref, () => setGallaryView(false));
  const isAuthanticate = localStorage.getItem("Token");
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [sharePopUp, SetSharePopUp] = useState(false);
  const [AuthPopUp, setAuthPopUp] = useState(false);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const handleFavoriteClick = () => {
    if (!isAuthanticate) {
      setAuthPopUp(true);
      return;
    }
    setPickerOpen(true);
  };

  return (
    <>
      <div
        className={`flex items-center justify-center w-full h-16 ${agentData?.primary_color ? "" : "bg-black"}`}
        style={agentData?.primary_color ? { backgroundColor: agentData.primary_color } : undefined}
      >
        <img src={agentData?.agencyLogo} alt="agency logo" className="h-10 object-cover" />
      </div>
      <Layout2 className="mt-8 px-5">
        {/* ================= TOP BAR ================= */}
        <div className="space-y-4">
          {/* Title + Actions */}
          <div className="flex md:flex-row md:items-center justify-between gap-4">
            {/* Left Side: Title + Address */}
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-[#171717]">
                {PropertyData?.street_address_name}
              </h1>

              <div className="flex items-center gap-2 text-gray-500 mt-1">
                <span className="text-sm md:text-base">
                  {PropertyData?.street_address_number}, {PropertyData?.suburb},{" "}
                  {PropertyData?.municipality}
                </span>
              </div>
            </div>

            {/* Right Side: Share + Favorite */}
            <div className="flex items-center gap:1 sm:gap-3">
              <button
                onClick={() => SetSharePopUp(true)}
                className="flex items-center gap-2 sm:border border-gray-200 px-4 py-2 rounded-full hover:bg-gray-50 transition"
              >
                <Share2 size={17} strokeWidth={3} color="#097FE6" />
                <span className="text-sm font-medium hidden sm:inline">
                  Share
                </span>
              </button>

              <button
                onClick={handleFavoriteClick}
                className="flex items-center gap-2 sm:border border-gray-200 px-4 py-2 rounded-full hover:bg-gray-50 transition"
              >
                {
                  isAuthanticate && PropertyData?.collections?.length > 0 ? (
                    <FaHeart color="#097FE6" size={16} />
                  ) : (
                    <FiHeart color="#097FE6" size={16} />
                  )
                }
                <span className="text-sm font-medium hidden sm:inline">
                  Favorite
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* ---------- Image Section ---------- */}
        <div className="mt-6 w-full">
          {/* ================= MOBILE VIEW ================= */}
          <div className="lg:hidden">
            {/* Main Image */}
            <div className="relative">
              <img
                src={
                  PropertyImages?.[selectedImageIndex]?.original ||
                  PropertyImages?.[0]?.original
                }
                alt="Main"
                className="w-full h-[320px] object-cover rounded-xl"
                onClick={() => setGallaryView(true)}
              />

              {/* Slide Indicator */}
              <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-3 py-1 rounded-full">
                {selectedImageIndex + 1} / {PropertyImages?.length}
              </div>

              {/* Price Overlay */}
              <div className="absolute bottom-3 left-3 bg-black/70 text-white text-sm font-semibold px-3 py-1 rounded-lg">
                {PropertyData?.price &&
                  PropertyData?.price_display_checked === "show_actual_price"
                  ? `${CurrencySymbol.NGN} ${String(PropertyData?.price).replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ",",
                  )}`
                  : PropertyData?.price_display}
              </div>
            </div>

            {/* Horizontal Thumbnails */}
            <div className="flex gap-3 overflow-x-auto mt-3 pb-2 scrollbar-hide">
              {PropertyImages?.map((img, index) => (
                <img
                  key={index}
                  src={img?.original}
                  alt="thumb"
                  onClick={() => setSelectedImageIndex(index)}
                  className={`w-28 h-20 object-cover rounded-lg cursor-pointer flex-shrink-0 border-2 ${selectedImageIndex === index
                    ? "border-[#097FE6]"
                    : "border-transparent"
                    }`}
                />
              ))}
            </div>
          </div>

          {/* ================= DESKTOP VIEW ================= */}
          <div className="hidden lg:grid grid-cols-4 gap-4">
            {/* LEFT: Main */}
            <div className="lg:col-span-3 relative cursor-pointer">
              <img
                src={PropertyImages?.[0]?.original}
                alt="Main"
                className="w-full h-[600px] object-cover rounded-2xl"
                onClick={() => setGallaryView(true)}
              />

              <div className="absolute bottom-4 left-4 bg-black/70 text-white text-2xl font-bold px-5 py-2 rounded-xl">
                {PropertyData?.price &&
                  PropertyData?.price_display_checked === "show_actual_price"
                  ? `${CurrencySymbol.NGN} ${String(PropertyData?.price).replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ",",
                  )}`
                  : PropertyData?.price_display}
              </div>
            </div>

            {/* RIGHT: Stacked */}
            <div className="flex flex-col gap-4">
              <img
                src={PropertyImages?.[1]?.original}
                alt="Side"
                className="w-full h-[290px] object-cover rounded-2xl cursor-pointer"
                onClick={() => setGallaryView(true)}
              />
              {/* Bottom Small Image */}
              <div
                className="relative cursor-pointer"
                onClick={() => {
                  setSelectedImageIndex(2);
                  setGallaryView(true);
                }}
              >
                <img
                  src={PropertyImages?.[2]?.original}
                  alt="Side 2"
                  className="w-full h-[290px] object-cover rounded-2xl"
                />

                {/* View All Photos Button */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setGallaryView(true);
                  }}
                  className="absolute flex items-center gap-2 bottom-4 right-4 bg-white px-3 py-2 rounded-md shadow-md hover:shadow-lg transition text-sm font-medium"
                >
                  <Image size={16} color="#097FE6" />
                  <div>View all photos</div>
                </button>
              </div>
            </div>
          </div>
        </div>
        {sharePopUp && (
          <SharePopup SetSharePopUp={SetSharePopUp} PropertyData={PropertyData} />
        )}
        {GallaryView && (
          <GallaryPopup
            data={PropertyImages}
            GallaryView={GallaryView}
            setGallaryView={setGallaryView}
          />
        )}

        <AuthModal open={AuthPopUp} onClose={() => setAuthPopUp(false)} />
        <CollectionPickerModal
          open={pickerOpen}
          onClose={() => setPickerOpen(false)}
          propertyId={PropertyData?._id || PropertyData?.id}
          initialSelectedIds={
            PropertyData?.collections?.map(
              (col) => col.id ?? col._id ?? col.collectionId,
            ) || []
          }
          onCreateNewCollection={() => setCreateModalOpen(true)}
        />
        {createModalOpen && (
          <CollectionCreateModal
            open={createModalOpen}
            onClose={() => setCreateModalOpen(false)}
            editingCollection={null}
            onSaved={() => { }}
          />
        )}
      </Layout2>
    </>
  );
};
